// import { useDispatch, useSelector } from "react-redux";
// import { get_po_backlog_state } from "../../../../../redux/po_backlog/backlog.selector";
import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
// import { handle_backlog_remarks_update } from "../../../../../redux/po_backlog/backlog.action";

export const OutputTableCellSelectNew = ({ key_name, excel_row, select_status, disabled, select_options, change_handler = () => { } }) => {
  // const backlog = useSelector(get_po_backlog_state);
  // const dispatch = useDispatch();
  const [selected_status, set_selected_status] = useState(select_status);
  useEffect(() => {
    set_selected_status(select_status);
  }, [select_status]);
  return (
    // <FormControl sx={{
    //   width: "100%"
    // }}>
    //   <InputLabel
    //     id={`${key_name}-${excel_row.id}-label`}
    //   >Status</InputLabel>
    // </FormControl>
    <Select
      sx={{
        width: "100%",

      }}
      labelId={`${key_name}-${excel_row.id}-label`}
      id={`${key_name}-${excel_row.id}`}
      value={selected_status || "Pending"}
      // label="Status"
      // size='small'
      onChange={(e) => {
        // console.log(e.target.value);
        change_handler(e.target.value, set_selected_status);
        // dispatch(handle_backlog_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
      }}
      disabled={disabled}
      size={"small"}
    >
      {
        select_options.map(({ value, label }, index) =>
          <MenuItem key={`${excel_row.id}-${value}-${label}-${key_name}-${index}`} value={value} >{label}</MenuItem>
        )
      }
    </Select>
  );
};